export enum ExtOperator {
  IS_VALID = "IS_VALID",
  IS_NOT_VALID = "IS_NOT_VALID",
}
